module.exports = {
    SENTRY_DSN:
        'https://5a48a333d202aad7c2783e0effc0d9f5@o4507551424315392.ingest.us.sentry.io/4507551434145792',
};
